import React from 'react'
import {Column, Row} from "simple-flexbox";
import {Button} from "@material-ui/core";
import CustomInput from "../../common/components/CustomInput";
import {history} from "../../managers/history";
import Divider from "@material-ui/core/Divider/Divider";


// function SubscriptionTypeComponent(props) {
//     return (
//         <div
//             className="p-3 cursor-pointer fc-dark-slate-blue text-center m-3 w-250 bg-white b-1-white subscription-plan-card-shadow z-index-100 br-4">
//             {/* <div className="fs-20 font-weight-bold">Loan Seller</div> */}
//             {/* <div className="fs-15 my-3">Create, transfer, sell and
//                 publish Loan Data Records
//                 on Blockchain
//             </div> */}
//             {/* <img/> */}
//             {/* <Button className="my-3 bg-blue px-2 fc-white fs-17 outline-none text-transform-capitalize">
//                 Buy this plan
//             </Button> */}
//         </div>
//     );
// }



function ResetPasswordForm(props) {
    let {state, onChangeEvent, onResetPasswordClicked} = props;
    return (
        <Column className="phone pt-5 ml-3 border-left py-3 my-3 w-520"
                horizontal={'center'}>
                    <img src="/images/DummyLogo.png" alt='Logo' className="w-120"/>
            <form onSubmit={onResetPasswordClicked} className="w-100 p-3">

            <Row className="justify-content-center w-100 fs-16 fc-1f1f1f ">
                    Reset your password here
                </Row>

                <div className=" reset-email mt-3">Email:</div>
                <CustomInput id="email" type="text" value={state ? state.email : ""} onChange={onChangeEvent}
                             error={state ? state.emailError : ""} className="fs-15 p-2 mt-1 h-55 bg-eee"/>

                <div className=" recovery">Enter Recovery Code:</div>
                <CustomInput id="recoverycode" type={"password"} value={state ? state.recoverycode : ""} onChange={onChangeEvent}
                             error={state ? state.recoverycodeError : ""} className="fs-15 p-2 mt-1 h-55 bg-eee"/>

                <Row className="fs-15 mt-2 font-weight-bold recovery-password">Select New Password:</Row>
                <CustomInput id="password" type={"password"} value={state ? state.password : ""}
                             onChange={onChangeEvent} error={state ? state.passwordError : ""}
                             className="fs-15 p-2 mt-1 h-55 bg-eee"/>

                <Row className="fs-15 mt-2 font-weight-bold confirm-password">Confirm New Password:</Row>
                <CustomInput id="confirmPassword" type={"password"} value={state ? state.confirmPassword : ""}
                             onChange={onChangeEvent} error={state ? state.confirmPasswordError : ""}
                             className="fs-15 p-2 mt-1 h-55 bg-eee"/>

                <Button type='submit' className="bg-blue outline-none text-transform-capitalize
                fc-white w-100 py-2 fs-17 mt-4 cursor-pointer h-63 reset-btn">
                    Reset Password
                </Button>
                
            </form>
        </Column>
    );
}



function ResetComponentPassword(props) {
    // let {state, togglePassword, onChangeEvent, onResetPasswordClicked} = props;
    return (
        <Row className="align-items-center my-5" horizontal={'center'}>
           
            {ResetPasswordForm(props)}
        </Row>
    );
}

function HeaderComponent(props) {
    return (
        <Row vertical="center" className="justify-content-between w-100">
            {/* <img src="/images/limb_logo.svg" alt='limb' className="w-150"/> */}
            <Row vertical="center">
                {/* <Column vertical="center" className="fc-brownish-grey fs-15 px-2 py-1">Existing user?</Column>
                <Column vertical="center" className="fc-blue br-4 b-1-blue fs-17 px-2 py-1 cursor-pointer"
                        onClick={() => history.replace("/")}>

                    Log in</Column> */}
            </Row>
        </Row>
    )
}



export default ResetComponentPassword;